
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Hostalinhinjewadiphaseformale() {



    const cardData =
    {
        keyword: 'Hostel in Hinjewadi Phase 3 for Male with AC Facilities ',
        heading: 'Shree Swami Samarth PG: Hostel in Hinjewadi Phase 3 for Male with AC Facilities',
        headingDescription: 'Shree Swami Samarth PG provides premium and affordable hostel in Hinjewadi Phase 3 for males with AC facilities, ensuring a comfortable and modern living experience for IT professionals and students. Our air-conditioned rooms are fully furnished with cozy bedding, ample storage, and study/work areas, offering a perfect balance of comfort and functionality. Located close to leading IT companies in Phase 3, the hostel ensures easy commuting while being well-connected to shopping centers, restaurants, and daily essentials. Residents benefit from hygienic home-cooked meals, high-speed WiFi, 24x7 water supply, CCTV surveillance, and regular housekeeping, making everyday living hassle-free. With disciplined management, secure surroundings, and budget-friendly rent plans, Shree Swami Samarth PG’s AC hostels in Hinjewadi Phase 3 are the perfect choice for male residents seeking reliable, safe, and comfortable accommodation in Pune.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Private or Shared AC Rooms",
    "description": "Hostels in Hinjewadi Phase 3 offer AC-equipped rooms ideal for male residents. Options range from thoughtfully laid-out single rooms to shared setups with equal comfort. These well-designed interiors include beds, wardrobes, study desks, and proper lighting—ensuring a cool and focused environment for students and professionals alike."
  },
  {
    "title": "Reliable High-Speed Wi-Fi & Power Backup",
    "description": "Many AC hostels in Phase 3 come with high-speed Wi-Fi connectivity across rooms and common areas, supporting seamless online classes or work. Complemented by consistent power backup, these hostels ensure uninterrupted productivity—even during local outages."
  },
  {
    "title": "Nutritious Meals & Clean Kitchen Areas",
    "description": "Some hostels also include hygienically cooked meals (breakfast, lunch, and dinner) as part of their packages. Kitchens are maintained under strict cleanliness standards, offering home-style dining that saves time and ensures well-balanced nutrition."
  },
  {
    "title": "24/7 Security & Safe Living Environment",
    "description": "Safety is a hallmark—many establishments provide CCTV surveillance, secure entry systems, and round-the-clock staff or security. Incoming visitors are regulated, giving residents peace of mind in a secure residential setting."
  },
  {
    "title": "Convenient Location Close to Work Hubs",
    "description": "Located close to Hinjewadi's commercial zones and IT parks, these hostels offer minimized commute times—ideal for professionals and students aiming to maximize productivity while reducing travel fatigue."
  },
  {
    "title": "Housekeeping & Laundry Services",
    "description": "Regular housekeeping services ensure the rooms and common areas are always neat and hygienic. Many hostels offer laundry services or in-house washing setups, making daily chores effortless."
  },
  {
    "title": "Community & Relaxation Spaces",
    "description": "Select hostels foster camaraderie with shared lounges, indoor games, or TV corners—great for unwinding after busy days and building social connections among male residents."
  },
  {
    "title": "Transparent Pricing & VALUE",
    "description": "AC single rooms typically range between ₹9,000–₹16,500/month depending on amenities. Twin sharing AC rooms can cost between ₹8,200–₹9,800/month. Most packages are all-inclusive—covering Wi-Fi, housekeeping, power backup, and essentials—providing excellent value with no hidden costs."
  }
],


"services": [
  {
    "name": "Hostel for Males in Hinjewadi Phase 3",
    "description": "Shree Swami Samarth PG offers well-maintained hostels exclusively for males in Hinjewadi Phase 3. Our facilities provide a safe, secure, and supportive environment with 24/7 security, clean common areas, and easy access to nearby IT parks, making it ideal for young professionals and students."
  },
  {
    "name": "AC Boys Hostel in Phase 3 Hinjewadi",
    "description": "Experience comfort and convenience with our AC Boys Hostel in Hinjewadi Phase 3. Fully furnished rooms with air-conditioning, attached bathrooms, high-speed internet, and regular housekeeping ensure a hassle-free living experience for working men."
  },
  {
    "name": "Working Men’s Hostel with AC in Hinjewadi",
    "description": "Designed specifically for working professionals, Shree Swami Samarth PG offers AC hostels in Hinjewadi that combine affordability with premium amenities. Enjoy uninterrupted power backup, nutritious meal plans, and common recreational spaces that foster a healthy work-life balance."
  },
  {
    "name": "PG for Males in Phase 3 with AC",
    "description": "Our AC PG accommodations for males in Hinjewadi Phase 3 provide private or shared rooms with modern amenities including air-conditioning, Wi-Fi, laundry services, and a secure environment. Perfect for IT employees and interns looking for convenient stays near their workplace."
  },
  {
    "name": "Air-Conditioned Hostel Near Tech Parks Hinjewadi",
    "description": "Located close to major tech parks in Hinjewadi, Shree Swami Samarth PG offers air-conditioned hostels equipped with comfortable beds, study desks, and safe living conditions. The proximity to workplaces reduces commute times and enhances overall convenience."
  },
  {
    "name": "Budget Hostel with AC for Males in Phase 3",
    "description": "Our budget-friendly AC hostels cater to males in Hinjewadi Phase 3 who seek quality accommodations without compromising on comfort. With affordable pricing, flexible rent plans, and essential amenities, we help professionals settle in quickly and comfortably."
  },
  {
    "name": "Furnished AC Hostel in Hinjewadi for Boys",
    "description": "Shree Swami Samarth PG provides furnished AC hostels for boys in Hinjewadi, combining elegant interiors with practical features. Rooms come with beds, wardrobes, study areas, and attached bathrooms, alongside common facilities like kitchens and lounge spaces."
  }
],
"tableData": [
  ["Hostel for Males in Hinjewadi Phase 3", "AC Boys Hostel in Phase 3 Hinjewadi"],
  ["Working Men’s Hostel with AC in Hinjewadi", "PG for Males in Phase 3 with AC"],
  ["Air-Conditioned Hostel Near Tech Parks Hinjewadi", "Budget Hostel with AC for Males in Phase 3"],
  ["Furnished AC Hostel in Hinjewadi for Boys", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "AC Hostel in Hinjewadi Phase 3 for Male Residents",
        "WhyChoosedescription": "Shree Swami Samarth PG offers a dedicated AC hostel for males in Hinjewadi Phase 3, providing comfortable and secure living spaces designed to meet the needs of students, interns, and working professionals."
    },
    {
        "WhyChooseheading": "Fully Air-Conditioned Rooms for Comfort",
        "WhyChoosedescription": "Our hostel features spacious, air-conditioned rooms equipped with comfortable beds, study desks, wardrobes, and high-speed Wi-Fi—ensuring a relaxing and productive environment even during Pune’s hot summers."
    },
    {
        "WhyChooseheading": "Strategic Location Near IT Parks and Educational Institutes",
        "WhyChoosedescription": "Located close to major IT companies and educational centers in Hinjewadi Phase 3, our hostel significantly reduces commute times and offers easy access to public transport and shared cabs."
    },
    {
        "WhyChooseheading": "Safe and Secure Environment for Male Residents",
        "WhyChoosedescription": "With 24/7 CCTV surveillance, biometric access control, and round-the-clock security staff, we ensure a safe living space where residents can focus on their work or studies without any concerns."
    },
    {
        "WhyChooseheading": "Nutritious Meals Included with Flexible Options",
        "WhyChoosedescription": "Enjoy hygienic and freshly prepared meals served three times daily, with vegetarian and non-vegetarian options available to cater to diverse dietary preferences."
    },
    {
        "WhyChooseheading": "All-Inclusive Rent Covering Utilities and Services",
        "WhyChoosedescription": "Our monthly rent includes accommodation, food, electricity, Wi-Fi, laundry, and housekeeping—providing a hassle-free living experience with no hidden charges or brokerage fees."
    },
    {
        "WhyChooseheading": "Community Living with Like-Minded Residents",
        "WhyChoosedescription": "Live alongside other male students and professionals in a respectful and friendly environment. Our hostel promotes a community spirit while maintaining individual privacy and comfort."
    },
    {
        "WhyChooseheading": "24/7 Support and Maintenance Services",
        "WhyChoosedescription": "Our dedicated staff is available around the clock to assist with any maintenance issues, emergencies, or general support—ensuring your stay is comfortable and worry-free."
    }
]
























    }
    
const faqData = [
    {
        question: "How can I book a hostel in Hinjewadi Phase 3 for males with AC facilities?",
        answer: "You can book by calling us at +91 9594917913. We also provide online booking support and virtual tours upon request."
    },
    {
        question: "Is your hostel in Hinjewadi Phase 3 exclusively for male residents?",
        answer: "Yes, we have a dedicated hostel for male residents with strict safety and privacy measures in place."
    },
    {
        question: "What AC facilities are available in the hostel rooms?",
        answer: "All rooms come with air conditioning units, comfortable beds, study tables, wardrobes, and attached or shared bathrooms."
    },
    {
        question: "Is food provided in the hostel for male residents?",
        answer: "Yes, we offer hygienic, freshly prepared vegetarian meals (breakfast, lunch, and dinner) included in the rent."
    },
    {
        question: "What amenities are available in the hostel?",
        answer: "Amenities include high-speed Wi-Fi, 24/7 security, CCTV surveillance, laundry services, power backup, and housekeeping."
    },
    {
        question: "How close is the hostel to major IT companies in Hinjewadi Phase 3?",
        answer: "Our hostel is conveniently located within 5–10 minutes commute to major tech parks like Tech Mahindra, Cognizant, and TCS."
    },
    {
        question: "What is the monthly rent for the AC hostel rooms for males?",
        answer: "Rent varies based on room type and occupancy. Please contact us directly for the best rates and current availability."
    },
    {
        question: "Is there a minimum stay duration for booking?",
        answer: "Yes, the minimum stay is one month. Long-term stays are welcome with flexible lease terms."
    },
    {
        question: "Are there any restrictions for residents in the male AC hostel?",
        answer: "We maintain strict discipline and safety guidelines to ensure a comfortable living environment for all residents."
    },
    {
        question: "How do I contact Shree Swami Samarth PG to book a male AC hostel room in Hinjewadi Phase 3?",
        answer: "Call us at +91 9594917913 to inquire about availability, schedule a visit, or book your room."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Patil',
        designation: 'Software Developer, Tech Mahindra Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“The AC rooms are comfortable and clean, with great security for male residents. Perfect location near my office in Hinjewadi Phase 3.”',
    },
    {
        name: 'Mr. Karan Singh',
        designation: 'IT Analyst, Cognizant Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“I highly recommend this male hostel. The AC facilities and overall management are excellent, making my stay hassle-free.”',
    },
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hostel in Hinjewadi Phase 3 for Male with AC Facilities",
  "image": "https://swamisamarthpg.com/assets/images/hostel-hinjewadi-phase3-male-ac.jpg", // Replace with actual image URL
  "description": "Comfortable and affordable AC hostel for males in Hinjewadi Phase 3. Ideal for working men near tech parks offering furnished rooms and excellent amenities.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.88",
    "ratingCount": "1600"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/hostel-hinjewadi-phase3-male-ac"  // Replace with actual page URL if different
  }
};




    return (
        <div>
<Helmet>
  <title>Hostel in Hinjewadi Phase 3 for Male with AC Facilities | Comfortable & Affordable</title>
  <meta 
    name="description" 
    content="Affordable AC hostel in Hinjewadi Phase 3 for males near tech parks. Furnished rooms with excellent amenities for working men." 
  />
  <meta 
    name="keywords" 
    content="Hostel for Males in Hinjewadi Phase 3, AC Boys Hostel in Phase 3 Hinjewadi, Working Men’s Hostel with AC in Hinjewadi, PG for Males in Phase 3 with AC, Air-Conditioned Hostel Near Tech Parks Hinjewadi, Budget Hostel with AC for Males in Phase 3, Furnished AC Hostel in Hinjewadi for Boys" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Hostalinhinjewadiphaseformale;